"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkServiceAuth = void 0;
var tslib_1 = require("tslib");
var tokenManager_1 = require("../userManagement/token/velvet/tokenManager");
/**
 * Represents a network session for making HTTP requests.
 * @class
 * Implements the NetworkSession interface.
 */
var NetworkServiceAuth = /** @class */ (function () {
    function NetworkServiceAuth(tokenManager, retryCount) {
        if (tokenManager === void 0) { tokenManager = new tokenManager_1.TokenManager(); }
        if (retryCount === void 0) { retryCount = 2; }
        this.retried = 0;
        this.tokenManager = tokenManager;
        this.retryCount = retryCount;
    }
    NetworkServiceAuth.prototype.fetch = function (requestable) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accessToken, response, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        accessToken = (_a = this.tokenManager.getTokens()) === null || _a === void 0 ? void 0 : _a.accessToken;
                        if (!accessToken) {
                            throw new Error('Access token is missing');
                        }
                        return [4 /*yield*/, fetch(requestable.url, {
                                method: requestable.method,
                                headers: tslib_1.__assign({ 'Content-Type': 'application/json', Authorization: "Bearer ".concat(accessToken) }, requestable.headers),
                                body: requestable.body ? JSON.stringify(requestable.body) : null,
                            })];
                    case 1:
                        response = _b.sent();
                        if (!(response.status >= 200 && response.status < 300)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        if (!(response.status === 401 || response.status === 403)) return [3 /*break*/, 5];
                        if (!NetworkServiceAuth.isRefreshing) {
                            NetworkServiceAuth.isRefreshing = true;
                            NetworkServiceAuth.tokenRefreshPromise = Promise.resolve().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, , 2, 3]);
                                            return [4 /*yield*/, this.tokenManager.refreshTokens()];
                                        case 1:
                                            _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            NetworkServiceAuth.isRefreshing = false;
                                            return [7 /*endfinally*/];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [4 /*yield*/, NetworkServiceAuth.tokenRefreshPromise];
                    case 4:
                        _b.sent();
                        this.retried += 1;
                        if (this.retried > this.retryCount) {
                            throw new Error('Retry limit exceeded');
                        }
                        return [2 /*return*/, this.fetch(requestable)];
                    case 5: return [4 /*yield*/, response.json()];
                    case 6: return [2 /*return*/, _b.sent()];
                    case 7:
                        error_1 = _b.sent();
                        console.error('Fetching data error:', error_1);
                        throw error_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    NetworkServiceAuth.isRefreshing = false;
    NetworkServiceAuth.tokenRefreshPromise = null;
    return NetworkServiceAuth;
}());
exports.NetworkServiceAuth = NetworkServiceAuth;
